import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {setApprovalProcess, setApprovalProcessAfter} from "../../../redux/slice/contentSlice";
import ApprovalComponent from "../approval/new/ApprovalComponent";

function GroupCodeApprovalLine({
    title,
    approvalProcessId,
    approvalSeparator = false,
    readOnly = false,
}) {
    const dispatch = useDispatch();
    const [cleared, setCleared] = useState(false);

    useEffect(() => {
        setCleared(false);
    }, [approvalProcessId]);

    const effectiveProcessId = cleared ? undefined : approvalProcessId;

    const handleApprovalProcessSet = useCallback((process) => {
        if (process?.id) {
            setCleared(false);
        } else {
            // 모달 초기화 등으로 결재선이 비워진 경우 — approvalProcessId를 놓아주지
            // 않으면 리마운트 시 지운 결재선이 되살아난다 (handleClear와 동일한 처리)
            setCleared(true);
        }

        if (approvalSeparator) {
            dispatch(setApprovalProcessAfter(process?.id ? {...process} : {}));
        } else {
            dispatch(setApprovalProcess(process?.id ? {...process} : {}));
        }
    }, [approvalSeparator, dispatch]);

    const handleClear = () => {
        setCleared(true);
        if (approvalSeparator) {
            dispatch(setApprovalProcessAfter({}));
        } else {
            dispatch(setApprovalProcess({}));
        }
    };

    return (
        <div className="group-code-approval-comp">
            <ApprovalComponent
                key={`${effectiveProcessId ?? "empty"}-${title}`}
                auth={!readOnly}
                readOnly={readOnly}
                title={title}
                approvalSeparator={approvalSeparator}
                approvalProcessId={effectiveProcessId}
                onApprovalProcessSet={handleApprovalProcessSet}
            />
            {!readOnly ? (
                <button type="button" className="group-code-approval-comp__clear" onClick={handleClear}>
                    결재라인 해제
                </button>
            ) : null}
        </div>
    );
}

export default function GroupCodeApprovalFields({code, showAfter = true, readOnly = false}) {
    const beforeLabel = showAfter ? "사전결재라인" : "결재라인";
    const beforeProcessId = code?.approvalProcessId ?? code?.approvalProcess?.id ?? null;
    const afterProcessId = code?.approvalProcessIdAfter ?? code?.approvalProcessAfter?.id ?? null;

    return (
        <div className="group-code-approval-fields">
            <GroupCodeApprovalLine
                title={beforeLabel}
                approvalProcessId={beforeProcessId}
                readOnly={readOnly}
            />
            {showAfter ? (
                <GroupCodeApprovalLine
                    title="사후결재라인"
                    approvalProcessId={afterProcessId}
                    approvalSeparator
                    readOnly={readOnly}
                />
            ) : null}
        </div>
    );
}
